import React from "react";
import Hero from "../sections/Hero";
import Story from "../sections/Story";
import Learned from "../sections/Learned";
import Work from "../sections/Work";
import Thoughts from "../sections/Thoughts";
import Contact from "../sections/Contact";

export default function Main() {
  return (
    <div data-testid="main-page">
      <Hero />
      <Story />
      <Learned />
      <Work />
      <Thoughts />
      <Contact />
    </div>
  );
}
